import { render, staticRenderFns } from "./FeedbackManagerPage.vue?vue&type=template&id=a67aac2e&scoped=true&lang=html&"
import script from "./FeedbackManagerPage.vue?vue&type=script&lang=js&"
export * from "./FeedbackManagerPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackManagerPage.vue?vue&type=style&index=0&id=a67aac2e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67aac2e",
  null
  
)

export default component.exports